import { USER_ROLES, USER_ROLES_LABELS } from '@/api/authService'
import debounce from '@/utils/debounce'
import locationsService from '@/api/locationsService'
import userService from '@/api/userService'
import i18n from '@/i18n'

const allOption = () => ({ id: 'all', name: i18n.t('ALL_CENTERS') })
const DEBOUNCE_TIME = 500

export default {
  name: 'UserForm',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      user: {
        first_name: null,
        last_name: null,
        email: null,
        email_repeat: null,
        password: null,
        password_repeat: null,
        role: null,
        shops: []
      },
      shopOptions: [],
      roleOptions: Object.keys(USER_ROLES)
        .filter(r => r !== 'ROOT')
        .map(key => ({
          id: key,
          name: USER_ROLES_LABELS[key]
        }))
    }
  },
  computed: {
    nameValid () {
      return this.user.first_name && this.user.last_name
    },
    emailValid () {
      return this.user.email && (
        this.user.id ? true : this.user.email_repeat === this.user.email
      )
    },
    passwordValid () {
      return this.user.id
        ? true
        : this.user.password && this.user.password === this.user.password_repeat
    },
    formValid () {
      return !this.loading &&
        this.nameValid &&
        this.emailValid &&
        this.passwordValid &&
        this.user.role
    },
    userid () {
      return this.$route.params.userid
    },
    isDirector () {
      return this.user.role && this.user.role.id === USER_ROLES.DIRECTOR
    },
    isPatrimony () {
      return this.user.role && this.user.role.id === USER_ROLES.AGENCY_PATRIMONY
    }
  },
  async mounted () {
    this._searchShops = debounce(this.searchShops, DEBOUNCE_TIME)
    this.searchShops('')
    if (this.userid !== 'new') {
      try {
        const user = await userService.getUser({ id: this.userid })
        if (user.shops === 'ALL_SHOPS_AVAILABLE') {
          user.shops = [allOption()]
        }
        this.user = {
          ...this.user,
          ...user,
          role: this.roleOptions.find(r => r.id === user.role)
        }
      } catch (err) {
        // eslint-disable-next-line
        console.error('[user-detail] Error fetching user', err)
      }
    }
  },
  methods: {
    closeModal () {
      this.$router.push('/users')
    },
    slowShopSearch (query) { this._searchShops(query) },
    searchShops (query) {
      return locationsService.getShops({ q: query, summary: 1 })
        .then(data => {
          const options = [allOption()].concat(data.results.map(opt => ({ id: Number(opt.value), name: opt.label })))
          this.$nextTick(() => {
            this.shopOptions = options
          })
          return options
        })
    },
    isShopSelected (opt) {
      return this.user.shops.find(shop => shop.id === opt.id)
    },
    onShopSelected (opt) {
      if (this.user.shops.some(shop => shop.id === opt.id)) {
        this.user.shops = this.user.shops.filter(shop => shop.id !== opt.id)
      } else {
        if (opt.id === 'all') {
          this.user.shops = [opt]
        } else {
          this.user.shops = this.user.shops.filter(s => s.id !== 'all').concat(opt)
        }
      }
    },
    isRolSelected (opt) {
      return this.user.role && this.user.role.id === opt.id
    },
    onRolSelected (opt) {
      this.user.role = opt
      this.$refs.roleSelect.close()
    },
    onComponentToggle () {
      window.setTimeout(() => {
        this.$refs.scrollbar.update()
      }, 250)
    },
    async save () {
      if (!this.formValid) {
        return
      }
      this.loading = true
      try {
        await userService.saveUser({
          ...this.user,
          role: this.user.role.id,
          shops: this.isDirector || this.isPatrimony ? this.user.shops.map(s => s.id) : [],
          password: this.user.id ? undefined : this.user.password
        })
        this.$emit('refetch')
        this.closeModal()
      } catch (err) {
        // eslint-disable-next-line
        console.error('[user-form.js] Error saving user', err)
      }
      this.loading = false
    }
  }
}
